module.exports = __webpack_public_path__ + "static/media/doctorDefault.8c522be1.png";